import AgentRegistrationRepository from "./../api/index"
import "../types"
import moment from "moment";

class  AgentRegistrationUseCase {
    constructor() {
        /** @type {AgentRegistrationRepository}*/
        this.api = new AgentRegistrationRepository()
    }

    /**
     *
     *  @param param {string}
     * @return {Promise<{data: Array<Agent>, err: null}|{data: null, err: ErrorState}>}
     */
    async getAll(param) {
        const {data, err} = await this.api.getAll(param)
        if (err && err === "record not found") {
            return {data: null, err: null}
        }
        data.forEach((element) => {
            element.created_at = moment(String(element.created_at)).format("MM/DD/YYYY hh:mm A");
        });
        return {data, err}
    }

    /**
     *
     * @param agentID {string}
     * @return {Promise<{data: Agent, err: null}|{data: null, err: ErrorState}>}
     */
     async getOne(agentID) {
        const {data, err} = await this.api.getOne(agentID)
        if (err && err === "record not found") {
            return {data: null, err: null}
        }
        data.created_at = moment(String(data.created_at)).format(
            "MM/DD/YYYY hh:mm A"
        );
        data.histories != null ? 
        data.histories.forEach((element) => {
            element.created_at = moment(String(element.created_at)).format(
              "MM/DD/YYYY hh:mm A"
            );
        }):''
        return {data, err}
    }

    /**
     *
     * @param formData {FormData}
     * @param agentID {string}
     * @return {Promise<{err: *}|{err: string}|{err: null}>}
     */
     async updateOne(formData, agentID) {
        return await this.api.updateOne(formData, agentID)
    }
}

export default new AgentRegistrationUseCase()
